import CouponComponent from '@/comman/CouponComponent';
import PaymentSection from '@/comman/PaymentSection';
import SavedCardOption from '@/comman/SavedCardOption';
import PointCollection from '@/components/checkoutSteps/components/PointCollection';
import { CheckboxClass, cn } from '@/services/Methods/normalMethods';
import { MenuItem, Select } from '@mui/material';
import { useFormikContext } from 'formik';
import Link from 'next/link';
import React, { useEffect } from 'react';
import { storeAssigned } from '@/services/Methods/normalMethods';
// import CreditCardLogo from '../../../assets/creditcarlogo.png';
// import PayPalLogo from '../../../assets/paypal-logo.png';
// import Image from 'next/image';


function CheckoutStepSix(props) {
    const {
        selectedPayment, formData, sameAsBillingChecked, setSameAsBillingChecked, _paymentOptionSetBilling,
        paymentOptions, paymentFormHtml, iframeLoader, savedThisCard, setSavedThisCard, _handleCardChange, savedCards,
        setSelectedPayment, error, couponCode, setCouponCode, _onCouponClick, couponErrorData, section,
        calculatedData, usePoint, setUsePoint, handleChangeFunction, orders, isCbd, cashPayNote, paymentOption_ID, referralerror,
        SINGLE_MEMBERSHIPCHECK, setFormData, isOrderTotalZero
    } = props;

    function _handlePaymentSectionSelection(num = 1) {
        if (setSameAsBillingChecked) {
            setSameAsBillingChecked(false);
        }
        setSelectedPayment((prv) => ({ ...prv, selectedOptionForPayment: num }))
    }

    const TOGGLE_CLASS = 'text-[#000] border-b border-[#000]';
    const fieldValue = useFormikContext();

    useEffect(() => {
        // if (paymentOption_ID?.paymentOptionTypeDescription === 'Redirect') {
        //     setUsePoint((prv) => ({
        //         wantToUSePoint: false,
        //         // paymentObject: { currencyCode: "USD", maxAmount: '', pointAccountType: 1, PaymentType: 2 }
        //     }));
        // }

    }, [selectedPayment])
    // console.log(selectedPayment, "selectedPayment")

    const rendersPDF = (country) => {
        const europeanCountries = [
            "eu", "mt", "cy", "be", "de", "pl", "ro", "si", "it", "es", "at", "se",
            "ie", "fi", "cz", "ru", "sk", "lt", "lv", "pt", "gr", "hu", "dk", "hr",
            "no", "is", "nl", "nc", "re", "bg", "fr", "gb", "rs", "lu", "ch", "ee"
        ];

        const asiaAfricaBrazilUSCanadaCountries = [
            "ca"
        ];

        if (asiaAfricaBrazilUSCanadaCountries.includes(country)) {
            return (
                <>
                    <Link href="/pdf/viago_termand_condition.pdf" className='ml-[3px] anchor-clr transition-all ease-in-out duration-300 hover:underline' target="_blank" >terms and conditions*</Link>
                </>
            );
        }

        if (europeanCountries.includes(country)) {
            return (
                <>
                    <Link href="/pdf/ClubViago-MembershipTerms&Conditions-EU-2.pdf" className='ml-[3px] anchor-clr transition-all ease-in-out duration-300 hover:underline' target="_blank" >terms and conditions*</Link>
                </>
            );
        }

        return (
            <>
                <Link href="/pdf/Club-Viago-MembershipTerms&Conditions.pdf" className='ml-[3px] anchor-clr transition-all ease-in-out duration-300 hover:underline' target="_blank" >terms and conditions*</Link>
            </>
        );

    };

    return (
        <div>
            {!isOrderTotalZero && <>
                <div className='w-full pb-[20px]'>
                    <div className={cn('mt-[10px]', { 'flex flex-col xl:gap-[34px] gap-6 w-full justify-between': calculatedData?.oneTimeCalculateData?.pointAccounts?.length > 0 })}>
                        {/* <CouponComponent {...{ couponCode, setCouponCode, _onCouponClick, couponErrorData }} /> */}
                        {(calculatedData?.oneTimeCalculateData?.pointAccounts?.length > 0 && selectedPayment?.selectedPaymentDropdown !== 3) &&
                            <PointCollection {...{ calculatedData, usePoint, setUsePoint, handleChangeFunction }} />
                        }
                    </div>
                </div>
                {(savedCards?.length > 0) &&
                    <div className='paymentOptions flex gap-[30px] mb-[34px]'>
                        <div onClick={() => {
                            _handlePaymentSectionSelection(1);
                            _handleCardChange(0, 'paymentOption0')
                            setSelectedPayment((prv) => ({ ...prv, selectedPaymentDropdown: 0 }));
                        }}
                            className={cn('p-[20px_0px_10px] cursor-pointer', { [TOGGLE_CLASS]: (selectedPayment?.selectedOptionForPayment === 1) })}>
                            Saved Payment Method
                        </div>
                        <div onClick={() => {
                            _handlePaymentSectionSelection(2);
                            _handleCardChange(paymentOptions[0]?.paymentOptionId, 'paymentOption')
                            if (paymentOptions?.length > 0) {
                                setSelectedPayment((prv) => ({ ...prv, selectedPaymentDropdown: paymentOptions[0]?.paymentOptionId }));
                            }
                        }} className={cn('p-[20px_0px_10px] cursor-pointer', { [TOGGLE_CLASS]: (selectedPayment?.selectedOptionForPayment === 2) })}>
                            Add New Payment Method
                        </div>


                    </div>
                }

                {/* {(selectedPayment?.selectedOptionForPayment === 2) && */}
                <>
                    {
                        (paymentOptions?.length > 0) && <>
                            <div className='credit_card_section'>
                                <Select
                                    className='w-full max-w-[50%] bg-white border border-[#DDDD]'
                                    value={selectedPayment?.selectedPaymentDropdown}
                                    onChange={(e) => {
                                        if (selectedPayment?.selectedOptionForPayment === 1) {
                                            _handleCardChange(+e.target.value, 'paymentOption0')
                                        } else {
                                            _handleCardChange(+e.target.value, 'paymentOption')
                                        }
                                    }}
                                    inputProps={{ 'aria-label': 'Without label' }}
                                >
                                    {selectedPayment?.selectedOptionForPayment === 1 && <MenuItem key={0} value={0}>Card on File</MenuItem>}
                                    {selectedPayment?.selectedOptionForPayment === 2 && _.map(paymentOptions, (row) => (
                                        <MenuItem key={row?.paymentOptionId} value={row?.paymentOptionId}>{row?.description}</MenuItem>
                                    ))}
                                </Select>
                            </div>
                            {/* {(paymentOption_ID?.description === 'Credit Card' || paymentOption_ID?.description === 'Card on File')
                         ?
                            <div className="justify-center flex mt-[10px]">
                                <Image src={CreditCardLogo} alt="" className="w-full h-full object-cover block max-w-56" />
                            </div>
                            :
                            (paymentOption_ID?.description === 'PayPal') &&
                            <div className="justify-center flex mt-[10px]">
                                <Image src={PayPalLogo} alt="" className="w-full h-full object-cover block max-w-[4rem]" />
                            </div>
                        } */}
                        </>
                    }
                    {
                        (selectedPayment?.selectedOptionForPayment === 1) &&
                        <div className='saved_card_section max-w-[708px] pt-[10px]'>
                            <SavedCardOption
                                title=""
                                section="savedCard"
                                optionData={savedCards}
                                checked={selectedPayment?.cardValue?.customerAccountId || selectedPayment?.cardValue?.nextAmount?.customerAccountId}
                                _onChangeFunction={(data) => _handleCardChange(data, 'savedCard')}
                            />
                        </div>
                    }
                    {(paymentOption_ID?.paymentOptionTypeDescription === 'iFrame' || paymentOption_ID?.secondaryRequestRequired) ?
                        <>
                            <div className="mt-4 items-center flex gap-[20px] sameAsShipping-checkbox ">
                                <label className='relative'>
                                    <input
                                        type="checkbox"
                                        className='w-[24px] h-[33px] absolute opacity-0 pointer-events-none peer'
                                        name="sameAsBilling"
                                        checked={sameAsBillingChecked}
                                        onChange={(e) => {
                                            if (e?.target?.checked) {
                                                setSameAsBillingChecked(e?.target?.checked);
                                                _paymentOptionSetBilling(formData);

                                            } else {
                                                setSameAsBillingChecked(e?.target?.checked);
                                                window.paymentOption?.clearBilling();
                                            }
                                        }} />
                                    {paymentOption_ID?.paymentOptionTypeDescription === 'iFrame' &&
                                        <span className={CheckboxClass}>
                                            Same as shipping
                                        </span>
                                    }
                                </label>
                            </div>
                            <PaymentSection {...{
                                selectedPayment,
                                minHeight: _.find(paymentOptions, { paymentOptionId: selectedPayment?.selectedPaymentDropdown })?.paymentOptionTypeDescription === 'iFrame' ? "550px" : "0px",
                                iframeLoader, paymentFormHtml, savedThisCard, setSavedThisCard, ...props
                            }} />
                        </>
                        :
                        <p className='mt-5 mb-[60px] text-[17px]'>{cashPayNote}</p>
                    }

                </>
                {/* } */}
            </>}


            {section !== 'distributorCheckout' &&
                <div className={cn('max-w-[611px]', 'checkboxes')}>
                    {
                        orders.length < 1 &&
                        <div className="mb-4 condition-checkout">
                            <p className='text-sm text-red-500 mt-1 mb-4'>{error || ''}</p>
                            <label className='relative'>
                                <input type="checkbox" className='w-[24px] h-[33px] absolute opacity-0 pointer-events-none peer'
                                    checked={fieldValue?.values?.termscondition || false}
                                    onChange={(e) => { fieldValue?.setFieldValue('termscondition', e.target.checked); }}
                                    name="termscondition" />
                                <span className={CheckboxClass}>I have read and agree to the website {rendersPDF(storeAssigned())}
                                    {/* <Link href="/pdf/Perfectly-Posh-Terms-and-Conditions_3.25.24.pdf" className='ml-[3px] anchor-clr transition-all ease-in-out duration-300 hover:underline' target="_blank" ></Link> */}
                                </span>
                            </label>
                            {fieldValue?.errors?.termscondition && <p className="text-sm text-red-500 mt-2">{fieldValue?.errors?.termscondition}</p>}
                        </div>
                    }
                    {SINGLE_MEMBERSHIPCHECK && _.upperCase(storeAssigned()) === 'JP' && <>
                        <div className="mb-4 condition-checkout">
                            <label className='relative'>
                                <input type="checkbox" className='w-[24px] h-[33px] absolute opacity-0 pointer-events-none peer'
                                    checked={fieldValue?.values?.gNumberTerms || false}
                                    onChange={(e) => { fieldValue?.setFieldValue('gNumberTerms', e.target.checked); }}
                                    name="gNumberTerms" />
                                <span className={CheckboxClass}>I have read and understand the content of Gaiyoshomen.</span>
                            </label>
                        </div>
                        <div className="mb-4 condition-checkout">
                            <label className='relative'>
                                <input type="checkbox" className='w-[24px] h-[33px] absolute opacity-0 pointer-events-none peer'
                                    checked={fieldValue?.values?.jpStudentTerms || false}
                                    onChange={(e) => { fieldValue?.setFieldValue('jpStudentTerms', e.target.checked); }}
                                    name="jpStudentTerms" />
                                <span className={CheckboxClass}>I am not a student.</span>
                            </label>
                            {(fieldValue?.errors?.gNumberTerms || fieldValue?.errors?.jpStudentTerms || fieldValue?.errors?.jpAgeTerms) && <p className="text-sm text-red-500 mt-2">{fieldValue?.errors?.gNumberTerms || fieldValue?.errors?.jpStudentTerms || fieldValue?.errors?.jpAgeTerms}</p>}
                        </div>
                        {/* <div className="mb-4 condition-checkout">
                            <label className='relative'>
                                <input type="checkbox" className='w-[24px] h-[33px] absolute opacity-0 pointer-events-none peer'
                                    checked={fieldValue?.values?.jpAgeTerms || false}
                                    onChange={(e) => { fieldValue?.setFieldValue('jpAgeTerms', e.target.checked); }}
                                    name="jpAgeTerms" />
                                <span className={CheckboxClass}>I am over 20 years old.</span>
                            </label>
                        </div> */}
                        <div className="mb-4 condition-checkout">
                            <label className='relative'>
                                <span >I am a citizen of Japan.</span>
                            </label>
                        </div>
                        <div className="mb-4 condition-checkout flex flex-wrap gap-[10px]">
                            <label className='relative'>
                                <input type="checkbox" className='w-[24px] h-[33px] absolute opacity-0 pointer-events-none peer'
                                    checked={fieldValue?.values?.jpCitizen === 'yes' ? true : false}
                                    onChange={(e) => { fieldValue?.setFieldValue('jpCitizen', 'yes'); }}
                                    onBlur={(e) => {
                                        fieldValue?.handleBlur(e);
                                        setFormData({ ...fieldValue?.values, jpCitizen: 'yes' });
                                    }}
                                    name="jpCitizen" />
                                <span className={CheckboxClass}>Yes</span>
                            </label>
                            <label className='relative'>
                                <input type="checkbox" className='w-[24px] h-[33px] absolute opacity-0 pointer-events-none peer'
                                    checked={fieldValue?.values?.jpCitizen === 'no' ? true : false}
                                    onChange={(e) => { fieldValue?.setFieldValue('jpCitizen', 'no'); }}
                                    onBlur={(e) => {
                                        fieldValue?.handleBlur(e);
                                        setFormData({ ...fieldValue?.values, jpCitizen: 'no' });
                                    }}
                                    name="jpCitizen" />
                                <span className={CheckboxClass}>No</span>
                            </label>
                            {fieldValue?.errors?.jpCitizen && <p className="text-sm text-red-500 mt-2 w-full">{fieldValue?.errors?.jpCitizen}</p>}
                            {fieldValue?.values?.jpCitizen === 'no' && <p className="text-sm text-red-500 mt-2 w-full">
                                Your enrollment is currently pending and put on hold. Customer Service will be in contact with you to gather further documentation needed at their earliest convenience.
                            </p>}
                        </div>
                    </>}
                    {
                        orders.length < 1 &&
                        <div className="mb-4 promotions-checkbox flex gap-[20px]">
                            <label className='relative'>
                                <input type="checkbox" checked={fieldValue?.values?.termscondition1} onChange={(e) => { fieldValue?.setFieldValue('termscondition1', e.target.checked); }} className='w-[24px] h-[33px] absolute opacity-0 pointer-events-none peer' name="termscondition1" />
                                <span className={CheckboxClass}>I want to receive updates about products and promotions.</span>
                            </label>
                        </div>
                    }
                </div>
            }
            <div>
                {referralerror && <p className="text-sm text-black mt-2">{referralerror}</p>}
            </div>
        </div >
    )
}

export default CheckoutStepSix;